import { DialogModule } from '@angular/cdk/dialog';
import {
  HTTP_INTERCEPTORS,
  provideHttpClient,
  withInterceptorsFromDi,
  withXhr
} from '@angular/common/http';
import {
  NgModule,
  isDevMode,
  inject,
  provideAppInitializer,
} from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { NgxSpinnerModule } from 'ngx-spinner';
import { ToastrModule } from 'ngx-toastr';

import {
  AUTH_CONFIG,
  ApiErrorInterceptor,
  BffUserService,
  ConfigurationService,
  DefaultHeadersInterceptor,
  PermissionService,
  UiModule,
} from '@canvas/four-r-digital';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { getAuthUserUrl } from './common/ApiKeys';
import { LoginComponent } from './static/login/login.component';
import { environment } from '../environments/environment';
import { ProductBootstrapService } from './common/services/product-bootstrap.service';

export function appInitialisation(
  configService: ConfigurationService,
  productBootstrapService: ProductBootstrapService,
  permissionService: PermissionService
) {
  return async () => {
    const epoch = new Date().getTime();

    const versionConfig = await fetch(
      `${environment.baseHRef}/assets/config.json?cache=${epoch}`
    );
    const json = await versionConfig.json();
    configService.setConfig(json);

    // Load the current user's permissions once per app refresh so guards,
    // directives and menu filters have them available synchronously.
    permissionService.loadPermissions().subscribe();

    productBootstrapService.initializeForProduct();

    if (isDevMode()) {
      console.log(
        `%c Version: ${configService.config.version} `,
        'background: green; color: white; display: block;'
      );
    }
  };
}

@NgModule({
  declarations: [AppComponent, LoginComponent],
  bootstrap: [AppComponent],
  imports: [
    BrowserModule,
    AppRoutingModule,
    UiModule,
    ToastrModule.forRoot({
      timeOut: 3000,
    }),
    BrowserAnimationsModule,
    DialogModule,
    NgxSpinnerModule,
  ],
  providers: [
    provideAppInitializer(() => {
      const initializerFn = ((
        configService: ConfigurationService,
        productBootstrapService: ProductBootstrapService,
        permissionService: PermissionService
      ) =>
        appInitialisation(
          configService,
          productBootstrapService,
          permissionService
        ))(
        inject(ConfigurationService),
        inject(ProductBootstrapService),
        inject(PermissionService)
      );
      return initializerFn();
    }),
    {
      provide: HTTP_INTERCEPTORS,
      useClass: DefaultHeadersInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ApiErrorInterceptor,
      multi: true,
    },
    { provide: AUTH_CONFIG, useValue: { authUrl: getAuthUserUrl() } },
    BffUserService,
    provideHttpClient(withXhr(), withInterceptorsFromDi()),
  ],
})
export class AppModule {}
